var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgShieldExpired = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 85,
    viewBox: "0 0 62 85",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.0323 45.8626C54.0323 56.5472 48.0431 64.42 30.5412 76.3212C13.0402 64.4209 7.05102 56.5481 7.05102 45.8626V18.7751C15.7548 17.8496 22.722 14.8885 30.5412 8.84127C38.3613 14.8885 45.3293 17.8496 54.0323 18.7742V45.8626ZM59.1703 12.3373C48.8763 12.1036 41.7978 9.62585 31.8274 1.13803C31.4695 0.833473 31.0045 0.679932 30.5412 0.679932C30.0762 0.679932 29.613 0.83263 29.255 1.13718C19.2872 9.62585 12.2087 12.1036 1.91385 12.3373C0.967596 12.3584 0.200317 13.1118 0.200317 14.0431V45.8626C0.200317 61.3315 10.7067 71.3412 29.1171 83.5292C29.5093 83.7899 30.0257 83.9198 30.5412 83.9198C31.0576 83.9198 31.5731 83.7899 31.9653 83.5292C50.3749 71.3412 60.883 61.3315 60.883 45.8626V14.0431C60.883 13.1118 60.1157 12.3584 59.1703 12.3373V12.3373Z",
    fill: "#D0D5DD"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgShieldExpired, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/shield_expired.06fdbd38.svg";
export { ForwardRef as ReactComponent };